export function accordionModule(module) {
  const rows = module.querySelectorAll(".accordion-item")
  const imageContainer = module.querySelector(".accordion__image-container")
  rows.forEach((row, index) => {
    row.addEventListener("click", (ev) => {
      const openImage = module.querySelector(".accordion__image:not(.accordion__image--hidden)")
      if (openImage) {
        openImage.classList.add("accordion__image--hidden")
      }
      imageContainer.children[index].classList.remove("accordion__image--hidden")
    })
  })
}
